import { Link, useLocation } from 'react-router-dom'
import './Header.css'

const Header = () => {
  const location = useLocation()
  
  const getActiveType = () => {
    const path = location.pathname
    if (path === '/') return 'all'
    if (path.startsWith('/school')) return 'school'
    if (path.startsWith('/seminar')) return 'seminar'
    if (path.startsWith('/workshop')) return 'workshop'
    return 'all'
  }

  const activeType = getActiveType()

  return (
    <header>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="site-title">ITCPR Events</Link>
          <nav className="main-nav">
            <Link 
              to="/" 
              className={`nav-tab ${activeType === 'all' ? 'active' : ''}`}
            >
              All Events
            </Link>
            <Link 
              to="/school" 
              className={`nav-tab ${activeType === 'school' ? 'active' : ''}`}
            >
              Schools
            </Link>
            <Link 
              to="/seminar" 
              className={`nav-tab ${activeType === 'seminar' ? 'active' : ''}`}
            >
              Seminars
            </Link>
            <Link 
              to="/workshop" 
              className={`nav-tab ${activeType === 'workshop' ? 'active' : ''}`}
            >
              Workshops
            </Link>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header

